// import { NavLink } from "react-router-dom";
import LanguageSwitcher from "../switchers/LanguageSwitcher";
import SignInModal from "../modals/SignInModal";
import { useTranslation } from "react-i18next";
import { mysaff_logo } from "src/routes/assets_paths/AssetsPaths";
import { useHeaderStore } from "src/store/layout/useHeaderStore";
import { Link } from "react-router-dom";
import { PATHS } from "src/routes/Paths";

export default function Header() {
  const { t } = useTranslation();
  const { isMenuOpen, toggleMenu } = useHeaderStore();

  return (
    <>
      <header className="sticky top-0 bg-success shadow z-50">
        <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
          <div className="flex items-center text-2xl w-full sm:w-auto justify-between">
          <Link to={PATHS.home}> 
          <div className="flex justify-center items-center gap-5 max-sm:items-center">
              <img
                className="w-auto h-14 max-sm:h-10 rounded-xl"
                src={mysaff_logo}
                alt="Logo"
              />
              <div className="text-[1.8rem] font-bold text-white max-sm:hidden">
                {t("SAFFCLOUD")}
              </div>
            </div>
          </Link>
            
            {/* Burger Menu Button - Only visible on small screens */}
            <button
              className="sm:hidden text-white hover:text-gray-200 focus:outline-none"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation - Hidden on small screens */}
          <div className="hidden sm:flex mt-4 sm:mt-0">
            {/* <NavLink className={({ isActive }) =>
                      `group relative flex items-center gap-2.5 rounded-sm px-4 py-2 font-medium text-gray-400 duration-300 ease-in-out 
                         hover:text-success  ${isActive ? "text-success" : ""}`
                    } to="/About">
              {t('AboutUs')}
              </NavLink> */}
            {/* <NavLink className={({ isActive }) =>
                      `group relative flex items-center gap-2.5 rounded-sm px-4 py-2 font-medium text-gray-50 duration-300 ease-in-out 
                      hover:text-secondary  ${isActive ? "text-success" : ""}`
                    } target="_blank" to="https://saff.sa">
                {t('SAFFWebsite')}
              </NavLink> */}
            {/* <NavLink className={({ isActive }) =>
                      `group relative flex items-center gap-2.5 rounded-sm px-4 py-2 font-medium text-gray-400 duration-300 ease-in-out 
                      hover:text-success ${isActive ? "text-success" : ""}`
                    } to="/TermsAndConditions">
              {t('TermsAndConditions')} 
              </NavLink> */}
          </div>

          {/* Desktop Actions - Hidden on small screens */}
          <div className="hidden sm:flex max-sm:hidden md:block">
            <div className="flex items-center justify-center gap-5">
              <div>
                <SignInModal />
              </div>

              <div className="mt-3">
                <LanguageSwitcher iconColor="white" iconSize={30} />
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu - Only visible when menu is open */}
        {isMenuOpen && (
          <div className="sm:hidden bg-success border-t border-white">
            <div className="px-8 py-4 space-y-4">
              {/* Mobile Navigation Items */}
              <div className="space-y-2">
                {/* <NavLink 
                  className="block text-white hover:text-gray-200 py-2 px-4 rounded transition-colors"
                  to="/About"
                  onClick={() => setMenuOpen(false)}
                >
                  {t('AboutUs')}
                </NavLink> */}
                {/* <NavLink 
                  className="block text-white hover:text-gray-200 py-2 px-4 rounded transition-colors"
                  target="_blank" 
                  to="https://saff.sa"
                  onClick={() => setMenuOpen(false)}
                >
                  {t('SAFFWebsite')}
                </NavLink> */}
                {/* <NavLink 
                  className="block text-white hover:text-gray-200 py-2 px-4 rounded transition-colors"
                  to="/TermsAndConditions"
                  onClick={() => setMenuOpen(false)}
                >
                  {t('TermsAndConditions')} 
                </NavLink> */}
              </div>

              {/* Mobile Actions */}
              <div className="pt-4  ">
                <div className="flex flex-col space-y-4">
                  <div>
                    <SignInModal />
                  </div>
                  <div className="flex justify-start mx-5">
                    <LanguageSwitcher iconColor="white" iconSize={30} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
}